var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"col-sm"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body text-center"},[_c('a',{attrs:{"href":"#/integrations"},on:{"click":function($event){$event.preventDefault();_vm.startIntegration($event)}}},[_c('img',{staticClass:"img-responsive",attrs:{"src":_vm.logo,"width":"80"}})])])])])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cabcff74","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/NewIntegrationShopify.vue
// module id = MXkB
// module chunks = 1